var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTcSocInst(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 7.5,
    fill: "#36F6FF",
    fillOpacity: 0.5,
    stroke: "#36F6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 9C21.5951 9 23.3928 8.9998 24.6875 9.85645C25.2657 10.239 25.761 10.7343 26.1436 11.3125C27.0002 12.6072 27 14.4049 27 18C27 21.5951 27.0002 23.3928 26.1436 24.6875C25.761 25.2657 25.2657 25.761 24.6875 26.1436C23.3928 27.0002 21.5951 27 18 27C14.4049 27 12.6072 27.0002 11.3125 26.1436C10.7343 25.761 10.239 25.2657 9.85645 24.6875C8.9998 23.3928 9 21.5951 9 18C9 14.4049 8.9998 12.6072 9.85645 11.3125C10.239 10.7343 10.7343 10.239 11.3125 9.85645C12.6072 8.9998 14.4049 9 18 9ZM17.999 13.3408C15.4258 13.3409 13.3399 15.4268 13.3398 18C13.3398 20.5733 15.4258 22.6591 17.999 22.6592C20.5723 22.6592 22.6582 20.5733 22.6582 18C22.6582 15.4267 20.5723 13.3408 17.999 13.3408ZM17.999 14.917C19.7017 14.917 21.082 16.2973 21.082 18C21.082 19.7027 19.7017 21.083 17.999 21.083C16.2964 21.0829 14.916 19.7026 14.916 18C14.916 16.2974 16.2964 14.9171 17.999 14.917ZM22.8428 12.0117C22.2382 12.0117 21.7481 12.5018 21.748 13.1064C21.748 13.7111 22.2381 14.2012 22.8428 14.2012C23.4474 14.2011 23.9375 13.7111 23.9375 13.1064C23.9374 12.5019 23.4473 12.0118 22.8428 12.0117Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTcSocInst);
export default __webpack_public_path__ + "static/media/tc_soc_inst.7d164af6afa45222aab4e151adcc0655.svg";
export { ForwardRef as ReactComponent };